var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", {}, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px",
              "border-style": "solid",
              "border-width": "1px",
              "border-color": "#eee"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c(
                  "div",
                  [
                    _c("el-row", { staticClass: "galy-header" }, [
                      _vm._v("\n            货位整合\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      {},
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "padding-top": "31px",
                              "border-right": "2px solid #ccc"
                            },
                            attrs: { span: 12 }
                          },
                          [
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "80px" } },
                              [_c("b", [_vm._v("区域商品整合配置")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "整合仓区:" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.form.checkIntegrationSpace,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "checkIntegrationSpace",
                                          $$v
                                        )
                                      },
                                      expression: "form.checkIntegrationSpace"
                                    }
                                  },
                                  _vm._l(_vm.spaceList, function(item) {
                                    return !_vm.form.checkUpSpace.includes(item)
                                      ? _c("el-option", {
                                          key: item,
                                          attrs: { label: item, value: item }
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "上架仓区:" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.form.checkUpSpace,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "checkUpSpace", $$v)
                                      },
                                      expression: "form.checkUpSpace"
                                    }
                                  },
                                  _vm._l(_vm.spaceList, function(item) {
                                    return !_vm.form.checkIntegrationSpace.includes(
                                      item
                                    )
                                      ? _c("el-option", {
                                          key: item,
                                          attrs: { label: item, value: item }
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否锁定上架仓位:" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.isUpSpaceLock,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "isUpSpaceLock", $$v)
                                      },
                                      expression: "form.isUpSpaceLock"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("是")
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v("否")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "仓位属性" } },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.form.areaCheckedSpaceAttribute,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "areaCheckedSpaceAttribute",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.areaCheckedSpaceAttribute"
                                    }
                                  },
                                  _vm._l(
                                    _vm.areaSpaceAttributeOptions,
                                    function(space) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: space.value,
                                          attrs: { label: space.value }
                                        },
                                        [_vm._v(_vm._s(space.label))]
                                      )
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "配货状态" } },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.form.areaCheckedShippedStatus,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "areaCheckedShippedStatus",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.areaCheckedShippedStatus"
                                    }
                                  },
                                  _vm._l(_vm.areaShippedStatusOptions, function(
                                    status
                                  ) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: status.value,
                                        attrs: { label: status.value }
                                      },
                                      [_vm._v(_vm._s(status.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "前置仓商品" } },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.form.areaQianZhi,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "areaQianZhi", $$v)
                                      },
                                      expression: "form.areaQianZhi"
                                    }
                                  },
                                  _vm._l(_vm.areaQianZhiOptions, function(
                                    status
                                  ) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: status.value,
                                        attrs: { label: status.value }
                                      },
                                      [_vm._v(_vm._s(status.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "在库时长:" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "20%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.areaInStockFromTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "areaInStockFromTime",
                                        $$v
                                      )
                                    },
                                    expression: "form.areaInStockFromTime"
                                  }
                                }),
                                _vm._v(
                                  "\n                ——\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "20%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.areaInStockToTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "areaInStockToTime",
                                        $$v
                                      )
                                    },
                                    expression: "form.areaInStockToTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "整合数量:" } },
                              [
                                _vm._v(
                                  "\n                单个任务商品件数小于等于\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "20%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.areaIntegrationNum,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "areaIntegrationNum",
                                        $$v
                                      )
                                    },
                                    expression: "form.areaIntegrationNum"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "80px" },
                                attrs: { label: "上架是否关联下架操作员:" }
                              },
                              [
                                _c("el-switch", {
                                  model: {
                                    value: _vm.form.areaConnect,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "areaConnect", $$v)
                                    },
                                    expression: "form.areaConnect"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { staticStyle: { float: "left" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.onAreaSubmit }
                                  },
                                  [_vm._v("保存")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "padding-top": "31px" },
                            attrs: { span: 6 }
                          },
                          [
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "100px" } },
                              [_c("b", [_vm._v("sku集中整合配置")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "整合仓区:" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择"
                                    },
                                    model: {
                                      value: _vm.form.checkIntegrationSkuSpace,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "checkIntegrationSkuSpace",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.checkIntegrationSkuSpace"
                                    }
                                  },
                                  _vm._l(_vm.stockShippingAreaList, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "30px" },
                                attrs: { label: "仓位属性:", prop: "ccc" }
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.form.skuCheckedSpaceAttribute,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "skuCheckedSpaceAttribute",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.skuCheckedSpaceAttribute"
                                    }
                                  },
                                  _vm._l(_vm.skuSpaceAttributeOptions, function(
                                    space
                                  ) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: space.value,
                                        attrs: { label: space.value }
                                      },
                                      [_vm._v(_vm._s(space.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "30px" },
                                attrs: { label: "配货状态:" }
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.form.skuCheckedShippedStatus,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "skuCheckedShippedStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.skuCheckedShippedStatus"
                                    }
                                  },
                                  _vm._l(_vm.skuShippedStatusOptions, function(
                                    status
                                  ) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: status.value,
                                        attrs: { label: status.value }
                                      },
                                      [_vm._v(_vm._s(status.label))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "90px" },
                                attrs: { label: "单个sku占用货位数:" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "50%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.fromSpaceNumBySku,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "fromSpaceNumBySku",
                                        $$v
                                      )
                                    },
                                    expression: "form.fromSpaceNumBySku"
                                  }
                                }),
                                _vm._v(
                                  "\n                ——\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "50%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.toSpaceNumBySku,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "toSpaceNumBySku", $$v)
                                    },
                                    expression: "form.toSpaceNumBySku"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "90px" },
                                attrs: { label: "单个货位待整合sku商品数:" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.fromSkuNumBySpace,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "fromSkuNumBySpace",
                                        $$v
                                      )
                                    },
                                    expression: "form.fromSkuNumBySpace"
                                  }
                                }),
                                _vm._v(
                                  "\n                ——\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.toSkuNumBySpace,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "toSkuNumBySpace", $$v)
                                    },
                                    expression: "form.toSkuNumBySpace"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "90px" },
                                attrs: { label: "上架仓位存放件数限制:" }
                              },
                              [
                                _vm._v(
                                  "\n                指定仓位整合上架后的商品总数小于等于\n                "
                                ),
                                _c("el-input", {
                                  staticStyle: { width: "50%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.spaceSkuNum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "spaceSkuNum", $$v)
                                    },
                                    expression: "form.spaceSkuNum"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "80px" },
                                attrs: { label: "上架是否关联下架操作员:" }
                              },
                              [
                                _c("el-switch", {
                                  model: {
                                    value: _vm.form.skuConnect,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "skuConnect", $$v)
                                    },
                                    expression: "form.skuConnect"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { staticStyle: { float: "left" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.onSkuSubmit }
                                  },
                                  [_vm._v("保存")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08846ca1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08846ca1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setting/GoodsIntegration.vue
// module id = null
// module chunks = 